import { api } from "@/config/api";
import * as Sentry from "@sentry/react-native";
import type { AxiosError } from "axios";

import { AppUserPUTFailReason } from "ipctg-inflow-types/InFlowEnums";
import type { ParkAppUserPUTErrorResponse, ParkAppUserPUTRequest, ParkAppUserPUTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";

export const updateAppUser = async (requestData: ParkAppUserPUTRequest): Promise<ParkAppUserPUTSuccessResponse> => {
  try {
    const response = await api.put<ParkAppUserPUTSuccessResponse>("/appuser", requestData);
    return response.data;
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        data: requestData,
        localStorage: Platform.OS === "web" ? window.localStorage : null,
      },
    });
    const axiosError = error as AxiosError<ParkAppUserPUTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: AppUserPUTFailReason };
  }
};
